/**
 * A share of an item whose sharing is still being applied by another share (GH #1535). The server answers 409 with
 * this message; approved copy, shown to the user as it is.
 */
export const shareBusyMessage = "This item's sharing is still being updated. Try again in a moment."

/**
 * Whether an RTK Query error is the share-busy 409. `POST /shares` sends the message as a bare JSON string, the
 * access-request approve route as `{ message }`, so both shapes count.
 */
export function isShareBusyError(error: unknown): error is { status: 409; data: unknown } {
  if (!error || typeof error !== 'object' || (error as { status?: unknown }).status !== 409) {
    return false
  }
  const data = (error as { data?: unknown }).data
  const message = data && typeof data === 'object' ? (data as { message?: unknown }).message : data
  return message === shareBusyMessage
}
